import { ApolloProvider } from '@apollo/client';
import moment from 'moment';
import React from 'react';
import { BrowserRouter } from "react-router-dom";
import { Main } from './components/layout';
import client from './utils/client';
import { FALLBACK_LANGUAGE } from './utils/language';

function App() {

  // App renders above the store provider, so it takes the language straight
  // from the url. It used to read the `language` cookie, which is only written
  // once the Preferências category is accepted - leaving moment on its default
  // English locale for anyone who refused.
  moment.locale(window.location.pathname.split('/')[1] || FALLBACK_LANGUAGE);
  
  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    </ApolloProvider>
  );
}

export default App;
